<template>
  <td>
    <template v-if="valueType == 'ListSerializer'">
      <table-cell-inner v-for="(item, $index) in value" :value="item" :valueType="childValueType" :key="$index"></table-cell-inner>
    </template>
    <table-cell-inner v-else :value="value" :valueType="valueType"></table-cell-inner>
  </td>
</template>
<script>
  import TableCellInner from 'components/elements/TableCellInner';

  export default {
    name: 'table-cell',
    components: {
      TableCellInner
    },
    props: {
      value: {
        required: false,
      },
      valueType: String,
      childValueType: {
        type: [String, null],
        required: false,
        default: null
      }
    }
  }
</script>
<style>
  td .label + .label {
    margin-left: .3rem;
  }
</style>



// WEBPACK FOOTER //
// TableCell.vue?076f2011